import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png';
import { Link } from 'react-router-dom';

const ModificarDirectora = () => {
  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Modificar Directora</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3">
          <div className="col-md-3">
            <label htmlFor="idDirectora" className="form-label">ID Directora</label>
            <input type="text" className="form-control" id="idDirectora" disabled />
          </div>

          <div className="col-md-3">
            <label htmlFor="idUsuario" className="form-label">ID Usuario</label>
            <input type="text" className="form-control" id="idUsuario" disabled />
          </div>

          <div className="col-md-6">
            <label className="form-label">Nombre</label>
            <input type="text" className="form-control" maxLength="30" />
          </div>

          <div className="col-md-3">
            <label className="form-label">Apellido Paterno</label>
            <input type="text" className="form-control" maxLength="30" />
          </div>

          <div className="col-md-3">
            <label className="form-label">Apellido Materno</label>
            <input type="text" className="form-control" maxLength="30" />
          </div>

          <div className="col-md-2">
            <label className="form-label">Sexo</label>
            <select className="form-select" defaultValue="">
              <option disabled value="">Seleccionar</option>
              <option value="F">Femenino</option>
              <option value="M">Masculino</option>
              <option value="O">Otro</option>
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label">Teléfono</label>
            <input type="text" className="form-control" />
          </div>

          <div className="col-md-6">
            <label className="form-label">Correo</label>
            <input type="email" className="form-control" maxLength="50" />
          </div>

          <div className="col-md-6">
            <label className="form-label">Fecha de Nacimiento</label>
            <input type="date" className="form-control" />
          </div>

          <div className="col-md-6">
            <label className="form-label">Puesto</label>
            <input type="text" className="form-control" maxLength="50" />
          </div>
          {/* Botones */}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button className="btn btn-warning px-4">Modificar</button>
            <Link to="/directora/inicio" className="btn btn-danger px-4">Salir</Link>
          </div>
        </form>
      </div>

      
    </div>
  );
};

export default ModificarDirectora;
